import React, { useState, useRef, useEffect } from 'react';
import forthSectionImage from '../assets/images/forthSection.jpg';
import forthSection1Image from '../assets/images/forthSection1.jpg';
import forthSection2Image from '../assets/images/forthSection2.jpg';
import useScrollAnimation from '../hooks/useScrollAnimation';
import './CustomizedCraftsmanshipSection.css';

const CustomizedCraftsmanshipSection = () => {
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const carouselRef = useRef(null);
  
  // Scroll animations
  const [sectionRef, isSectionVisible] = useScrollAnimation(0.6);
  const [titleRef, isTitleVisible] = useScrollAnimation(0.7);
  const [carouselAnimRef, isCarouselVisible] = useScrollAnimation(0.8);
  
  // Combine refs for carousel functionality
  const combinedCarouselRef = (node) => {
    carouselRef.current = node;
    carouselAnimRef.current = node;
  };

  const images = [
    { src: forthSectionImage, alt: 'Customized Craftsmanship 1' },
    { src: forthSection1Image, alt: 'Customized Craftsmanship 2' },
    { src: forthSection2Image, alt: 'Customized Craftsmanship 3' }
  ];

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - carouselRef.current.offsetLeft);
    setScrollLeft(carouselRef.current.scrollLeft);
    carouselRef.current.style.cursor = 'grabbing';
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
    carouselRef.current.style.cursor = 'grab';
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    carouselRef.current.style.cursor = 'grab';
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - carouselRef.current.offsetLeft;
    const walk = (x - startX) * 2; // Scroll speed multiplier
    carouselRef.current.scrollLeft = scrollLeft - walk;
    checkScrollPosition();
  };

  // Touch events for mobile
  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX - carouselRef.current.offsetLeft);
    setScrollLeft(carouselRef.current.scrollLeft);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const x = e.touches[0].pageX - carouselRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    carouselRef.current.scrollLeft = scrollLeft - walk;
    checkScrollPosition();
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  const checkScrollPosition = () => {
    if (carouselRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current;
      // Only add padding when third image is completely visible (no tolerance)
      const isAtEnd = scrollLeft >= scrollWidth - clientWidth;
      setIsAtEnd(isAtEnd);
    }
  };

  useEffect(() => {
    checkScrollPosition();
  }, []);

  return (
    <section ref={sectionRef} className="customized-craftsmanship-section">
      <div className="craftsmanship-container">
        <div className="craftsmanship-text-row">
          <div ref={titleRef} className={`craftsmanship-text-left ${isTitleVisible ? 'visible' : ''}`}>
            <h2 className={`craftsmanship-title text-reveal ${isTitleVisible ? 'visible' : ''}`}>CUSTOMIZED CRAFTSMANSHIP</h2>
          </div>
          <div className={`craftsmanship-text-right ${isTitleVisible ? 'visible' : ''}`}>
            <p className={`craftsmanship-description text-reveal stagger-1 ${isTitleVisible ? 'visible' : ''}`}>
              We provide customisation options for our buyers. We can exact design with top most qualify according to your requirements.
            </p>
          </div>
        </div>
        
        <div 
          ref={combinedCarouselRef}
          className={`craftsmanship-carousel ${isCarouselVisible ? 'visible' : ''}`}
          style={{ 
            paddingRight: isAtEnd ? '1.5rem' : '0',
          }}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          onScroll={checkScrollPosition}
        >
          <div className="carousel-track">
            {images.map((image, index) => (
              <div key={index} className={`carousel-item fade-in ${isCarouselVisible ? 'visible' : ''}`}>
                <img 
                  src={image.src} 
                  alt={image.alt} 
                  className={`carousel-image image-reveal ${isCarouselVisible ? 'visible' : ''}`}
                  draggable={false}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomizedCraftsmanshipSection;
